(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball/assets/javascripts/ball-keno.js') >= 0) return;  svs.modules.push('/components/tur/ball/assets/javascripts/ball-keno.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};


class BallKeno extends svs.tur.ball.Default {
  constructor(options) {
    options.productId = 'Keno';
    super(options);
    this.log = new svs.core.log.Logger('ball.keno');
    if (options.kungKeno) {
      this.isHuxFluxable = false;
    }
  }

  createDomElements() {
    super.createDomElements();
    if (this.kungKeno) {
      this.$el.removeChild(this.$inner);
    }
    if (!this.number && !this.kungKeno) {
      this.empty = true;
    }
  }
  setNumber(number) {
    super.setNumber(number);
    if (this.empty && number) {
      this.$el.classList.remove('ball-empty');
    }
  }
  classNames() {
    const classNames = ['ball-keno'];
    if (this.kungKeno) {
      classNames.push('ball-kungKeno');
    }
    if (!this.number && !this.kungKeno) {
      classNames.push('ball-empty');
    }
    return classNames;
  }
  addCrown() {
    let visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    this.$crown = this.createElement('kungKeno-crown');
    this.$crown.endX = '14%';
    this.$crown.endY = '-58%';
    this.$crown.rotation = '13';
    this.$crown.style.transform = "translate3d(".concat(this.$crown.endX, ", ").concat(this.$crown.endY, ", 0) rotate(").concat(this.$crown.rotation, "deg)");
    this.$crown.style.zIndex = 20;
    if (!visible) {
      this.$crown.style.opacity = 0;
    }
    this.$el.appendChild(this.$crown);
  }
  clear() {
    this.$el.classList.add('ball-empty');
    return super.clear();
  }
}
svs.tur.ball.Keno = BallKeno;

 })(window);